import { Seo } from "@/components/Seo";
import { Reveal, PageHero } from "@/components/shared";
import { Search, BrainCircuit, Wrench } from "lucide-react";

const principles = [
  { icon: Search, n: "01", title: "Repérer les évolutions", text: "Observer les signaux susceptibles d'affecter les PME, avant qu'ils ne deviennent des contraintes immédiates." },
  { icon: BrainCircuit, n: "02", title: "Comprendre les conséquences", text: "Traduire une évolution en effets concrets possibles sur l'organisation, les responsabilités ou les pratiques." },
  { icon: Wrench, n: "03", title: "Préparer les adaptations", text: "Anticiper plutôt que subir : identifier les ajustements utiles pour aborder les changements avec sérénité." },
];

export default function Reglementations() {
  return (
    <>
      <Seo
        title="Réglementations — BENZENATI"
        description="Comprendre avant de subir : une lecture accessible des évolutions réglementaires susceptibles de concerner les PME, dans une démarche prudente et pédagogique."
      />
      <PageHero
        label="Réglementations & vigilance"
        title="Comprendre avant de subir"
        intro="Les évolutions réglementaires touchent progressivement l'ensemble des entreprises. Les anticiper, même partiellement, permet de les aborder avec plus de sérénité et de recul."
        testid="reg-hero"
      />

      <section className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-testid="reg-principles">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          {principles.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div className="flex h-full flex-col border border-bz-line bg-white p-10" data-testid={`reg-principle-${i}`}>
                <div className="flex items-center gap-4">
                  <span className="font-serif text-2xl text-bz-amber">{p.n}</span>
                  <p.icon size={26} strokeWidth={1.2} className="text-bz-petrol" />
                </div>
                <h3 className="mt-6 font-serif text-xl text-bz-navy">{p.title}</h3>
                <p className="mt-4 text-base leading-relaxed text-bz-slate">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-16 border border-bz-line bg-bz-ivory2 p-10 lg:p-12" data-testid="reg-warning">
            <span className="bz-label text-bz-petrol">Avertissement</span>
            <p className="mt-5 text-base leading-relaxed text-bz-slate lg:text-lg">
              Les contenus publiés par BENZENATI ont une vocation informative et pédagogique. Ils ne remplacent pas les conseils d'un expert-comptable, d'un avocat, d'un juriste ou de tout autre professionnel habilité.
            </p>
          </div>
        </Reveal>
      </section>
    </>
  );
}
